import {registry} from 'records';
import {List} from 'immutable';
import WorkingSetIcon from 'records/WorkingSetIcon';
import WorkingSetTypeface from 'records/WorkingSetTypeface';
import WorkingSetImage from 'records/WorkingSetImage';
import {MUTATION_TYPE_CREATED} from 'reducers/publish';

export function addedForRecord(kitMutations, kitToken, record) {
  const kitMutationsPath = ['changesSinceLastPublish', kitToken, registry.typeFor(record), MUTATION_TYPE_CREATED];

  return kitMutations.getIn(kitMutationsPath, List());
}

export function iconsAdded(kitMutations, kitToken) {
  return addedForRecord(kitMutations, kitToken, WorkingSetIcon);
}

export function typefacesAdded(kitMutations, kitToken) {
  return addedForRecord(kitMutations, kitToken, WorkingSetTypeface);
}

export function imagesAdded(kitMutations, kitToken) {
  return addedForRecord(kitMutations, kitToken, WorkingSetImage);
}

export function needsPublishing(kitMutations, kitToken) {
  const kitMutationsPath = ['changesSinceLastPublish', kitToken];

  return kitMutations.getIn(kitMutationsPath, List()).size > 0;
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/utils/kit.js